import { Component, OnDestroy, OnInit } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { UtilsService } from 'src/app/services/utils.service';
import { SidePanelService } from 'src/app/shared/services/side-pannel/side-pannel.service';
import { MrsiService } from '../service/mrsi.service';

@Component({
  selector: 'app-overall-feedback',
  templateUrl: './overall-feedback.component.html',
  styleUrls: ['./overall-feedback.component.scss']
})
export class OverallFeedbackComponent implements OnInit, OnDestroy {
  public eventList:any[] = [{},{}]
  public scrollDistance = 1;
  public throttle = 10;
  public page = 1;
  constructor(public mrsiService:MrsiService, public sidePanelService:SidePanelService,
    public notifier: NotifierService,
    public utility:UtilsService) { 
  }

  ngOnInit(): void {
    this.mrsiService.feedbackSearchText = "";
    this.mrsiService.feedbackList = [];
    this.getEvents();
    this.mrsiService.getFeedbackList(1);
  }

  ngOnDestroy(): void {
    this.mrsiService.feedbackSearchText = "";
    this.mrsiService.feedbackList = [];
  }

  getEvents(){
    this.mrsiService.getEventsApi()
    .subscribe(res=>{
      if (res['status'] == 1) {
        this.mrsiService.mrsiEventList = res['result'];
        if(res['count']){
          this.sidePanelService.mrsiEventListOverallCountDetails = res['count'];
        }
        // console.log(this.mrsiService.mrsiEventList);
        this.sidePanelService.initSideDrawer('mrsi');
      }else{
        this.notifier.notify('error', 'Something went wrong');
      }
    })
}

onSearchChange(str){
  this.mrsiService.feedbackSearchText = str;
  if (str.length> 2) {
    this.mrsiService.getFeedbackList(1);
  }else if(str.length == 0){
    this.mrsiService.getFeedbackList(1);
  }
}

copyText(feedback, name, organization){
  // let str = question + " " +name+ " "+organization
  let str = name;
  if (organization && organization != '') {
    str += " from "+organization
  }
  str += " has feedback - "+feedback;
  this.utility.copyOnClick(str);
}

copyAllData(){
  let str = ""
  for (let i = 0; i < this.mrsiService.feedbackList.length; i++) {
    // str = str + this.mrsiService.feedbackList[i]['text'] + " " +this.mrsiService.feedbackList[i]['name'] + " " +this.mrsiService.feedbackList[i]['organization'] + "\n" 
    if (this.mrsiService.feedbackList[i]['text']) {
      // str = str + this.mrsiService.feedbackList[i]['text'] + "\n" 
      str += this.mrsiService.feedbackList[i]['name'];
      if (this.mrsiService.feedbackList[i]['organization']) {
        str += " from "+this.mrsiService.feedbackList[i]['organization']
      }
      str += " has feedback - "+this.mrsiService.feedbackList[i]['text']+ "\n\n"
    }
    if (i == this.mrsiService.feedbackList.length -1) {
      this.utility.copyOnClick(str);
    }
  }
}

onScroll(){
  let page = +this.mrsiService.apiPageCountForFeedback;
  if((page+1) <= this.mrsiService.totalPages){
    this.mrsiService.getFeedbackList(page+1);
  }
}

refresh(){
  this.mrsiService.feedbackList = [];
  this.mrsiService.getFeedbackList(1,true);
  // this.getEvents();
  this.mrsiService.scrollToTop()
}



  // getOverallCount(){
  //   return this.sidePanelService.mrsiEventListOverallCountDetails['feedback'] ? this.sidePanelService.mrsiEventListOverallCountDetails['feedback']:0;
  // }

}
